import { Card, Fade, Icon, Modal, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
// Kaizen Dashboard components
import { gql, useLazyQuery } from "@apollo/client";
import Loading from "components/Carteles/Loading";
import SinDatos from "components/Carteles/SinDatos";
import CustomPagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DataTable from "components/Tables/DataTable";
import { useEffect, useState } from "react";
import ModalControlCalidad from "../ModalControlCalidad";
import SoftButton from "components/SoftButton";
import dataControlesCalidad from "../data/dataControlesCalidad";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "60%" },
};

export default function ModalHistorialControlCalidad({ open, handleClose, idProducto }) {
  const { columns, getRows } = dataControlesCalidad;
  const [selectedItem, setSelectedItem] = useState(null);
  const [openModalControlCalidad, setOpenModalControlCalidad] = useState(false);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [pagesInfo, setPagesInfo] = useState({
    pages: 0,
    total: 0,
  });

  const [getControles, { data, loading }] = useLazyQuery(
    gql`
      query controlesCalidadProducto($pagination: PaginationInput, $order: Order) {
        paginationInfo {
          pages
          total
        }
        controlesCalidadProducto(pagination: $pagination, order: $order) {
          id
          fecha
          estado
          resultado
          usuario {
            nombre
            apellido
          }
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
      cachePolicy: "no-cache",
    }
  );

  useEffect(() => {
    if (open) {
      getControles({
        variables: {
          pagination: { page: page, limit: 20 },
          order: { field: "id", order: "DESC" },
        },
      }).then((res) => {
        setRows(
          getRows(res.data.controlesCalidadProducto, (item) => {
            setSelectedItem(item);
            setOpenModalControlCalidad(true);
          })
        );
        setPagesInfo(res.data.paginationInfo);
      });
    } else {
      setRows([]);
      setPagesInfo({
        pages: 0,
        total: 0,
      });
      setPage(1);
      setSelectedItem(null);
      setOpenModalControlCalidad(false);
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" flexDirection="column" gap={2}>
            <SoftBox display="flex" justifyContent="space-between" p={3} pb={0}>
              <SoftBox>
                <SoftTypography variant="h6">Controles de calidad realizados</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="flex-end" gap={2} alignItems="center">
                <Tooltip title="Agregar un nuevo control de calidad" placement="top">
                  <SoftButton
                    color="primary"
                    circular
                    sx={{
                      display: { xs: "none", sm: "flex" },
                    }}
                    onClick={() => {
                      setSelectedItem(null);
                      setOpenModalControlCalidad(true);
                    }}
                  >
                    <Icon>add</Icon>
                    &nbsp;Agregar
                  </SoftButton>
                </Tooltip>
                <Tooltip title="Cerrar" placement="top">
                  <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                    close
                  </Icon>
                </Tooltip>
              </SoftBox>
            </SoftBox>
            <SoftBox>
              {loading ? (
                <Loading />
              ) : rows?.length > 0 ? (
                <DataTable columns={columns} rows={rows} />
              ) : (
                <SinDatos />
              )}
              <CustomPagination
                loading={loading}
                length={data?.controlesCalidadProducto?.length}
                total={pagesInfo?.total}
                pages={pagesInfo?.pages}
                page={page}
                setPage={setPage}
                noCard
              />
            </SoftBox>
            <ModalControlCalidad
              open={openModalControlCalidad}
              handleClose={() => setOpenModalControlCalidad(false)}
              idProducto={idProducto}
              idControl={selectedItem?.id}
              refetch={() => {
                getControles({
                  variables: {
                    pagination: { page: page, limit: 20 },
                    order: { field: "id", order: "DESC" },
                  },
                }).then((res) => {
                  setRows(
                    getRows(res.data.controlesCalidadProducto, (item) => {
                      setSelectedItem(item);
                      setOpenModalControlCalidad(true);
                    })
                  );
                  setPagesInfo(res.data.paginationInfo);
                });
              }}
            />
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalHistorialControlCalidad.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  idProducto: PropTypes.string,
};
